import { render } from "./ProductUpdatePhoto.vue?vue&type=template&id=0eccacf0&scoped=true"
import script from "./ProductUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./ProductUpdatePhoto.vue?vue&type=script&lang=js"

import "./ProductUpdatePhoto.vue?vue&type=style&index=0&id=0eccacf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eccacf0"]])

export default __exports__